import { Link } from '@tanstack/react-router';

const legalLinks = [
  { to: '/legal/privacy' as const, label: 'Privacy Policy' },
  { to: '/legal/terms' as const, label: 'Terms of Service' },
  { to: '/legal/cookies' as const, label: 'Cookie Policy' },
];

export function Footer() {
  return (
    <footer className="border-t bg-background/95 backdrop-blur supports-[backdrop-filter]:bg-background/60">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {/* Brand */}
          <div>
            <Link to="/" className="inline-block">
              <h2 className="font-display text-2xl font-black text-foreground tracking-tight">
                W<span className="text-terra">u</span>ndra
              </h2>
            </Link>
            <p className="mt-3 text-sm text-muted-foreground">
              AI assisted travel planning that feels like dreaming.
            </p>
          </div>

          {/* Legal */}
          <div>
            <h3 className="font-display text-sm font-bold text-foreground mb-3">
              Legal
            </h3>
            <ul className="space-y-2">
              {legalLinks.map((link) => (
                <li key={link.to}>
                  <Link
                    to={link.to}
                    className="text-sm text-muted-foreground hover:text-terra transition-colors"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h3 className="font-display text-sm font-bold text-foreground mb-3">
              Contact
            </h3>
            <a
              href="mailto:hello@wundra.app"
              className="text-sm text-muted-foreground hover:text-terra transition-colors"
            >
              hello@wundra.app
            </a>
          </div>
        </div>

        {/* Bottom bar */}
        <div className="mt-10 pt-6 border-t border-border">
          <p className="text-xs text-muted-foreground text-center">
            &copy; {new Date().getFullYear()} Grateful8 Consulting LLC. All
            rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
}
